export default __webpack_public_path__ + "static/media/e-review.bee117d2.png";